import { useEffect, useState } from 'react'

/**
 * `value`, but only once it has stopped changing for `delayMs`. Lets a search
 * box drive a server query without a request per keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(id)
  }, [value, delayMs])
  return debounced
}
